module.exports = __webpack_public_path__ + "img/invest-page-icon.0abe8f57.svg";